import React from "react";
import { Button, Card } from "react-bootstrap";
import SkeletonLoader from "components/ui/SkeletonLoader";
import { FaCrown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "store";
import './SubscriptionCard.css';

const SubscriptionCard: React.FC = () => {
    const navigate = useNavigate();
    const reduxBalance = useSelector((state: RootState) => state.credits.balance);
    const isLoading = useSelector((state: RootState) => state.credits.isLoading && !state.credits.balance);

    const creditBalance = reduxBalance?.availableCredits ?? (reduxBalance as any)?.credits_balance ?? (reduxBalance as any)?.totalCredits ?? 0;

    const showPaymentPage = () => {
        navigate("/payment");
    };

    const isLowCredits = (creditBalance ?? 0) < 50;

    return (
        <Card className="text-white border-0 Subscription_Card">
            <div>
                <div className="sub-card-header">
                    <FaCrown color="#fff" className="sub-card-crown-icon" />
                    <span className="text-white collabe_subscription_card sub-card-title">
                        Your Credits
                    </span>
                </div>

                <div className="d-flex justify-content-between align-items-center collabe_subscription_card sub-card-body">
                    {isLoading ? (
                        <SkeletonLoader inline width={18} height={18} style={{ borderRadius: 4 }} />
                    ) : (
                        <span className={`sub-card-balance ${isLowCredits ? 'low-credits' : 'normal-credits'}`}>
                            {creditBalance ?? 0}
                        </span>
                    )}

                    <Button
                        variant="primary"
                        className="sub-card-buy-btn"
                        onClick={() => showPaymentPage()}
                    >
                        Buy More
                    </Button>
                </div>
                {isLowCredits && (
                    <p className="collabe_subscription_card sub-card-warning-text">
                        You're running low on credits
                    </p>
                )}
            </div>
        </Card>
    );
};

export default SubscriptionCard;
